<template>
  <div>
      <Header></Header>
      <section class="commerecial_customer" data-scroll-container> 
        <div class="section section_one" data-scroll-section>
            <div class="underMainContent">
                <div class="container-fluid"> 
                    <div class="innerMain">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="image_parent">
                                    <div class="image_main image-reveal">
                                        <div class="revealer"></div>
                                        <img src="@/assets/images/custumer/SmartphonesWife2.png" alt="" class="img-fluid">
                                    </div>
                                    
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="innerText flex-div" data-aos="fade-left">
                                    <h4>
                                        ”زين للأعمال“:<br/> المُشغّل المفضّل لدى <br/>الحكومات والشركات
                                    </h4>
                                    <p class="desc">عزَّزت مجموعة زين مكانتها في قطاع المشاريع والأعمال، باعتبارها المُشغّل المفضل لدى الكيانات الحكومية والشركات بجميع أحجامها، إذ قامت باستثمارات استراتيجية في منصاتها الرقمية، والخدمات المبتكرة لتلبية الاحتياجات دائمة التغيُّر في مجالات حلول الاتصالات المتنقلة والثابتة وإنترنت الأشياء وخدمات الأمن المُدارة.
                                    </p>
                                </div>
                                
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
        <div class="section section_three baharain" data-scroll-section>
            <div class="underMainContent">
                <div class="container-fluid">
                    <div class="innerMain">
                        <div class="sectionInner">
                            <!-- <div class="section-title">
                                <h5>COMMERCIAL <span>&</span> CUSTOMER EXPERIENCE</h5>
                            </div> -->
                           <div class="section-Text-Overlay" data-scroll data-scroll-speed="2">
                                    <h4 class="text-uppercase">زين البحرين</h4>
                                </div>
                            <div class="main_content small-width height-for-center">
                                 
                                <div class="container_grid">
                                   <div class="row first_row" data-scroll data-scroll-speed="3">
                                       <div class="col-md-6">
                                           <div class="main_card">
                                               <div class="card_custom first_card">
                                                   <div class="cardImage image-reveal">
                                                       <div class="revealer"></div>
                                                       <img src="@/assets/images/custumer/baharain-1.png" alt="" class="img-fluid">
                                                   </div>
                                                   <div class="cardCotent">
                                                       <p>أطلقت شركة زين البحرين باقات 
                                                        لخدمات النطاق العريض (برودباند)
                                                        القائمـة علـى األليـاف البصريـة 
                                                        بسرعات تصل إلى 500 ميغابت/
                                                        ثانيـة، وذلـك لدعـم وتعزيـز رحلـة 
                                                        التحول الرقمي للعملاء.
                                                       </p>
                                                   </div>
                                               </div>
                                           </div>
                                       </div>
                                       <div class="col-md-6">
                                           <div class="main_card ">
                                               <div class="card_custom card_two">
                                                   <div class="cardImage image-reveal">
                                                       <div class="revealer"></div>
                                                       <img src="@/assets/images/custumer/baharain-3.png" alt="" class="img-fluid">
                                                   </div>
                                                   <div class="cardCotent">
                                                       <p>طرحت الشركة مجموعة متناسقة من الحلول القائمة على الألياف البصرية لتلبية احتياجات الشركات الصغيرة والمتوسطة في البحرين.
                                                       </p>
                                                   </div>
                                               </div>
                                           </div>
                                       </div>
                                   </div>
                                   <div class="row second_row mt-30" data-scroll data-scroll-speed="-1">
                                       <div class="col-12">
                                           <div class="main_card card_three">
                                               <div class="card_custom ">
                                                   <div class="cardImage image-reveal">
                                                       <div class="revealer"></div>
                                                       <img src="@/assets/images/custumer/baharain-2.png" alt="" class="img-fluid">
                                                   </div>
                                                   <div class="cardCotent">
                                                       <p>أطلقت شركة زين البحرين خدمة موحدة لإدارة التهديدات الأمنية من خلال شراكتها مع شركة Fortinet، هذه الخدمة القائمة على السحابة الإلكترونية هي عبارة عن حل أمني شامل مصمم لزيادة حماية الشبكات، الأمن، التحكم من خلال برمجيات مكافحة الفيروسات، الحماية ضد البرمجيات الضارة، تصفية (فلترة) المحتوى، جدار الحماية، نظام رصد التسللات، نظام الحماية ضد التسللات، ومراقبة التهديدات.
                                                       </p>
                                                   </div>
                                               </div>
                                           </div>
                                       </div>
                                   </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="section section_two kuwait" data-scroll-section>
            <div class="underMainContent">
                <div class="container-fluid">
                    <div class="innerMain">
                        <div class="sectionInner p-relative h-100">
                            <!-- <div class="section-title" >
                                <h5 data-aos="fade-left">COMMERCIAL <span>&</span> CUSTOMER EXPERIENCE</h5>
                            </div> -->
                            <div class="section-Text-Overlay" data-scroll data-scroll-speed="2">
                                <h4 class="text-uppercase">زين الكويت</h4>
                            </div>
                            <div class="main_section medium-width height-for-center">
                                <div class="row">
                                    <div class="col-md-6 p-relative left-section" >
                                       
                                        <div class="img_floting image-reveal">
                                            <div class="revealer"></div>
                                            <img src="@/assets/images/custumer/EdTGIudWoAExcWU.png" alt="" class="img-fluid">
                                        </div>
                                        <div class="text_float">
                                            <p data-aos="fade-left">بدأت شركة زين الكويت في تقديم خدمات الكاميرات الحرارية لعملائها من الشركات، وإذ تعمل هذه الكاميرات عبر شبكة زين، فإنها تستطيع قياس درجة حرارة الجسم من مسافة آمنة في أقل من ثانية، كما يُسهِّل نظام الكاميرات هذا تسجيل درجات الحرارة لمجموعات كبيرة من الأشخاص يصل عددهم إلى 30 فرداً في وقت واحد. 
                                            هذا الحل مُجهز أيضاً بالذكاء الاصطناعي (AI)، الذي يسمح بالتعرف على وجوه الأشخاص، ويقوم بمطابقة الصور مع درجات حرارة الجسم المسجلة في السابق، وتعمل وظيفة المطابقة في الحالات التي يرتدي فيها الأشخاص الكمامات والأقنعة. تعمل هذه الكاميرات أيضاً ككاميرات مراقبة دوائر تلفزيونية مغلقة (CCTV)، حيث تسجل لقطات على 
                                            مدار الساعة.
                                            </p>
                                        </div>
                                        <div class="clear"></div>
                                    </div>
                                    <div class="col-md-6 right-section" >
                                        <div class="innerBox upperBox mb-4">
                                            <div class="box_container">
                                                <div class="innerImage image-reveal">
                                                    <div class="revealer"></div>
                                                    <img src="@/assets/images/custumer/Zain_B2B_Classera.png" alt="" class="img-fluid">
                                                </div>
                                                <div class="innerText">
                                                    <p data-aos="fade-left">دخلت الشركة في شراكة مع منصة ”كلاسيرا“ (Classera) لتقديم حلول إدارة التعلُّم (LMS) من أجل تسهيل التعلُّم الإلكتروني ودعم الجامعات والمدارس والمعلمين والطلاب والأسر، للإسهام في التكيف بشكل أفضل مع التعلُّم عن بُعد أثناء جائحة كوفيد-19.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="innerBox bottomBox">
                                            <div class="box_container">
                                                <div class="innerImage image-reveal">
                                                    <div class="revealer"></div>
                                                    <img src="@/assets/images/custumer/Zain_B2B_Classera-2.png" alt="" class="img-fluid">
                                                </div>
                                                <div class="innerText">
                                                    <p data-aos="fade-left">تم استخدام خدمة البث المباشر عبر الإنترنت من زين لإدارة اجتماعات الجمعية العمومية للمساهمين سواء لشركات زين أو الشركات الأخرى، وذلك كمنصة بديلة للاجتماعات الفعلية، ويدعم هـذا الحـل لوائـح هيئـة أسـواق المـال بشـأن تنظيـم جمعيات المساهمين، مع إبقاء المشاركين على مسافات آمنة.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="section section_four sudan" data-scroll-section>
            <div class="underMainContent">
                <div class="container-fluid">
                    <div class="innerMain">
                        <div class="sectionInner">
                            
                            <div class="section-Text-Overlay" data-scroll data-scroll-speed="2">
                                <h4 class="text-uppercase">زين السودان</h4>
                            </div>
                            <div class="main_content height-for-center">
                                <div class="container_grid">
                                   <div class="row first_row" data-scroll data-scroll-speed="3">
                                       <div class="col-md-6">
                                           <div class="main_card first_card">
                                               <div class="card_custom">
                                                   <div class="cardImage image-reveal">
                                                       <div class="revealer"></div>
                                                       <img src="@/assets/images/custumer/sudan-1.png" alt="" class="img-fluid">
                                                   </div>
                                                   <div class="cardCotent">
                                                       <p>”مشروع المؤسسة السودانية للنفط“ هو حل اتصال تجاري يوفر لموزعي الوقـود ومحطـات الخدمـة وصـولاً آمناً وخاصاً ومخصصاً عن بُعد إلى مقار عملهم وإلى مقر وزارة النفط باستخدام شبكة زين. يمكّن هذا المشروع الوزارة وشركات التوزيع من مراقبة توزيع الوقود بنجاح من خلال توفير ربط آمن وفعّال من حيث التكلفة بين محطات الوقود.
                                                       </p>
                                                       
                                                   </div>
                                               </div>
                                           </div>
                                       </div>
                                       <div class="col-md-6">
                                           <div class="main_card ">
                                               <div class="card_custom card_two">
                                                   <div class="cardImage image-reveal">
                                                       <div class="revealer"></div>
                                                       <img src="@/assets/images/custumer/sudan-2.png" alt="" class="img-fluid">
                                                   </div>
                                                   <div class="cardCotent">
                                                       <p>تطبيق ”حقول“ هو أول منتج زراعي ذكي تطرحه 
                                                        شركة زين السودان، وهو يهدف إلى دعم المزارعين 
                                                        لزيادة اإلنتاجية وتقليل النفقات التشغيلية.
                                                        يوفر تطبيق ”حقول“ للمزارعين أربعة مؤشرات يتم 
                                                        تشييدها من صور عالية الجودة مأخوذة من األقمار 
                                                        االصطناعية لتمكينهم من مراقبة وتحليل صحة 
                                                        المحاصيل ورطوبة التربة والغطاء األخضر.
                                                       </p>
                                                   </div>
                                               </div>
                                           </div>
                                       </div>
                                   </div>
                                   <div class="row second_row justify-content-center" data-scroll data-scroll-speed="4">
                                       <div class="col-md-8">
                                           <div class="main_card card_three">
                                               <div class="card_custom">
                                                   <div class="cardImage image-reveal">
                                                       <div class="revealer"></div>
                                                       <img src="@/assets/images/custumer/sudan-3.png" alt="" class="img-fluid">
                                                   </div>
                                                   <div class="cardCotent">
                                                       <p>كجزء من جهود زين لدعم تجارب التعلُّم المبتكرة في السودان من خلال تقنيات المعلومات والاتصالات، أطلقـت شركـة زيـن السـودان منظومـة إدارة التعليـم الإلكتروني ”ZEES“ الذي يوفر منصة تعليمية عالية الجودة للمعلمين والطلاب.
                                                       </p>
                                                       <p>منصة ”ZEES“ هي منظومة شاملة ومتكاملة ومتقدمة لإدارة مؤسسات التعلُّم عن بُعد، ويمكن تطبيقها في الجامعات والمدارس والمعاهد والكليات، وهي مصممة لرفع مستوى التفاعل بين الطلاب والمعلمين وأولياء الأمور والإدارة. </p>
                                                        <p>غيّرت هذه المنصة الأنظمة الإدارية التقليدية والأنشطة التعليمية داخل المؤسسات، حيث حولتها إلى نظام إلكتروني ذكي وتفاعلي يمكن الوصول إليه من أي مكان عبر السحابة الإلكترونية.</p>
                                                   </div>
                                               </div>
                                           </div>
                                       </div>
                                   </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- new added  -->
        <div class="section section_four saudia" data-scroll-section>
            <div class="underMainContent">
                <div class="container-fluid">
                    <div class="innerMain">
                        <div class="sectionInner">
                            <!-- <div class="section-title">
                                <h5>COMMERCIAL <span>&</span> CUSTOMER EXPERIENCE</h5>
                            </div> -->
                            <div class="section-Text-Overlay" data-scroll data-scroll-speed="2" >
                                <h4 class="text-uppercase">زين السعودية</h4>
                            </div>
                            <div class="main_content height-for-center">
                                <div class="container_grid">
                                   <div class="row first_row">
                                       <div class="col-md-4 col-sm-6 mx-auto" data-scroll data-scroll-speed="1">
                                           <div class="main_card first_card">
                                               <div class="card_custom">
                                                   <div class="cardImage image-reveal"> 
                                                       <div class="revealer"></div>
                                                       <img src="@/assets/images/custumer/saudia-1.png" alt="" class="img-fluid">
                                                   </div>
                                                   <div class="cardCotent">
                                                       <p>أطلقت شركة زين السعودية Samsung Knox، وهو حل أمان متعدد الطبقات للأجهزة النقالة لمعالجة المخاوف الأمنية على الأجهزة التي تعمل بنظام التشغيل ”أندرويد“. 
                                                       </p>
                                                       
                                                   </div>
                                               </div>
                                           </div>
                                       </div>
                                       <div class="col-md-4 col-sm-6 mx-auto" data-scroll data-scroll-speed="1">
                                           <div class="main_card ">
                                               <div class="card_custom card_two">
                                                   <div class="cardImage image-reveal">
                                                       <div class="revealer"></div>
                                                       <img src="@/assets/images/custumer/saudia-2.png" alt="" class="img-fluid">
                                                   </div>
                                                   <div class="cardCotent">
                                                       <p>أطلقت الشركة ”حزمة/باقة المعلمين“، وهي عرض واسع النطاق مع جهاز كمبيوتر شخصي لدعم التعليم عن بُعد.
                                                       </p>
                                                   </div>
                                               </div>
                                           </div>
                                       </div>
                                       <div class="col-md-4 col-sm-6 mx-auto" data-scroll data-scroll-speed="1">
                                           <div class="main_card card_three">
                                               <div class="card_custom">
                                                   <div class="cardImage image-reveal">
                                                       <div class="revealer"></div>
                                                       <img src="@/assets/images/custumer/saudia-3.png" alt="" class="img-fluid">
                                                   </div>
                                                   <div class="cardCotent">
                                                       <p>تم إطلاق بطاقات e-SIM الإلكترونية في السعودية لعملاء الأعمال، وهو الأمر الذي يتيح تجربة البيع بدون تلامس، وبطاقات e-SIM متاحة الآن لعملاء الأعمال في كلٍ من الكويت والسعودية والبحرين والأردن.
                                                       </p>
                                                       
                                                   </div>
                                               </div>
                                           </div>
                                       </div>
                                       <div class="col-md-4 col-sm-6 mx-auto" data-scroll data-scroll-speed="1">
                                           <div class="main_card first_card">
                                               <div class="card_custom">
                                                   <div class="cardImage image-reveal">
                                                       <div class="revealer"></div>
                                                       <img src="@/assets/images/custumer/saudia-4.png" alt="" class="img-fluid">
                                                   </div>
                                                   <div class="cardCotent">
                                                       <p>أطلقت شركة زين السعودية خدمات ”الألياف البصرية إلى قطاع الأعمال“ (FTTB)، لتزويد عملاء خدمات B2B بين الشركات باتصال إنترنت عالي النطاق الترددي عبر الألياف البصرية.
                                                       </p>
                                                       
                                                   </div>
                                               </div>
                                           </div>
                                       </div>

                                       <div class="col-md-4 col-sm-6 mx-auto" data-scroll data-scroll-speed="1">
                                           <div class="main_card ">
                                               <div class="card_custom card_two">
                                                   <div class="cardImage image-reveal">
                                                       <div class="revealer"></div>
                                                       <img src="@/assets/images/custumer/saudia-5.png" alt="" class="img-fluid">
                                                   </div>
                                                   <div class="cardCotent">
                                                       <p>أطلقت الشركة خدمات IP-VPN (الشبكة الافتراضية الدوليّة الخاصة لبروتوكول الإنترنت) مخصصة عبر شبكة الجيل الخامس من خلال الاستفادة من شبكة الجيل الخامس فائقة السرعة الخاصة بشركة زين السعودية، وذلك لبناء شبكات بيانات والربط بين مقار العملاء والمستودعات والفروع والمتاجر وما إلى ذلك، على شبكة واحدة. 
                                                       </p>
                                                   </div>
                                               </div>
                                           </div>
                                       </div>
                                       <div class="col-md-4 col-sm-6 mx-auto" data-scroll data-scroll-speed="1">
                                           <div class="main_card card_three">
                                               <div class="card_custom">
                                                   <div class="cardImage image-reveal">
                                                       <div class="revealer"></div>
                                                       <img src="@/assets/images/custumer/saudia-6.png" alt="" class="img-fluid">
                                                   </div>
                                                   <div class="cardCotent">
                                                       <p>أطلقت الشركة خدمات ”الوصول المباشر إلى الإنترنت“ (DIA) عبر شبكة الجيل الخامس، حيث يعتبر ”الوصول المباشر إلى الإنترنت“ بمثابة تقنية بديلة للهواتف الثابتة، إذ تستخدم زين شبكة الجيل الخامس الرائدة لتزويد عملاء B2B بين الشركات باتصال إنترنت مخصص عالي السرعة.
                                                       </p>
                                                       
                                                   </div>
                                               </div>
                                           </div>
                                       </div>
                                       <div class="col-md-4 col-sm-6 mx-auto" data-scroll data-scroll-speed="1">
                                           <div class="main_card first_card">
                                               <div class="card_custom">
                                                   <div class="cardImage image-reveal">
                                                       <div class="revealer"></div>
                                                       <img src="@/assets/images/custumer/saudia-7.png" alt="" class="img-fluid">
                                                   </div>
                                                   <div class="cardCotent">
                                                       <p>أطلقت الشركة خدمة توجيه 
                                                        مُدارة توفر للعملاء خدمات إدارة 
                                                        LAN-WAN شاملة بين الطرفين، التي تشمل النطاق الترددي والاتصال بالإنترنت وأجهزة شبكات LAN. 
                                                       </p>
                                                       
                                                   </div>
                                               </div>
                                           </div>
                                       </div>
                                       <div class="col-md-4 col-sm-6 mx-auto" data-scroll data-scroll-speed="1">
                                           <div class="main_card first_card card_custom">
                                               <div>
                                                   <div class="img_floting image-reveal">
                                                       <div class="revealer"></div>
                                                       <img src="@/assets/images/custumer/saudia-8.png" alt="" class="img-fluid">
                                                   </div> 
                                                   <div class="text_floting cardCotent">
                                                       <p>أطلقت زين مجموعة متناسقة كاملة من الخدمات السحابية التي تتنوع من ”البنية التحتية كخدمة“ (IaaS) إلى ”البرمجيات كخدمة“ (SaaS).
                                                       </p>
                                                       <p>يشمل عرض البنية التحتية خدمات الحوسبة المرنة، وخدمات التخزين، ومُوازِن أحمال السيرفر.</p>
                                                        <p>تقدم زين ”التطبيب عن بُعد“ (TaaS)، و”الأشعة عن بُعد“، و”الفحص الحراري”، و”الاتصالات الموحدة”.</p>
                                                   </div>
                                                   <div class="clear"></div>
                                               </div>
                                           </div>
                                       </div>
                                   </div>
                                   
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        

        <!-- jordAN  -->
        <div class="section section_four jordan" data-scroll-section>
            <div class="underMainContent">
                <div class="container-fluid">
                    <div class="innerMain">
                        <div class="sectionInner">
                            <!-- <div class="section-title">
                                <h5>COMMERCIAL <span>&</span> CUSTOMER EXPERIENCE</h5>
                            </div> -->
                            <div class="section-Text-Overlay" data-scroll data-scroll-speed="2">
                                <h4 class="text-uppercase">زين الأردن</h4>
                            </div>
                            <div class="main_content medium-width height-for-center">
                                <div class="container_grid">
                                   <div class="row first_row align-itoms-md-start align-itoms-center" data-scroll data-scroll-speed="5">
                                       <div class="col-md-6 mx-auto">
                                           <div class="main_card first_card">
                                               <div class="img-">
                                                   <div class="img_floting cardImage image-reveal">
                                                       <div class="revealer"></div>
                                                       <img src="@/assets/images/custumer/jordan-1.png" alt="" class="img-fluid">
                                                   </div>
                                                   <div class="cardCotent text_float">
                                                       <p>أطلقت شركة زين الأردن عروضاً متكاملة لتكنولوجيا المعلومات والاتصالات الثابتة والمتنقلة للشركات الصغيرة والمتوسطة، التزاما منها بتحقيق وعدها بتقديم متجر شامل للمكاتب المنزلية وللشركات الصغيرة والمتوسطة.
                                                       </p>
                                                       
                                                   </div>
                                                   <div class="clear"></div>
                                               </div>
                                           </div>
                                       </div>
                                       <div class="col-md-6 mx-auto">
                                           <div class="main_card ">
                                               <div class="">
                                                   <div class="img_floting cardImage image-reveal">
                                                       <div class="revealer"></div>
                                                       <img src="@/assets/images/custumer/jordan-2.png" alt="" class="img-fluid">
                                                   </div>
                                                   <div class="cardCotent text_float">
                                                       <p>تعرف الشركة أن النهج المبتكر والمرونة هما عاملان يساعدان على نمو الأعمال، ومن توسيع المحفظة لتشمل السحابة والأمن مع خدمات الصوت والاتصال، فقد وضعت ”زين للأعمال“  الحلول التي تدعم العملاء في إدارة تعقيدات الاتصالات التجارية. </p>
                                                       <p>في العام 2020، أطلقت زين الأردن مجموعة متناسقة كاملة من الخدمات السحابية والأمن بالتعاون مع ”زين داتا بارك“ مع استضافتها مباشرة من مركز  Bunker The، بما في ذلك حلول” جدار حماية التطبيقات” (WAF) و”هجمات حجب الخدمة الموزعة (DDOS)، و”البنية التحتية كخدمة” (IaaS). </p>
                                                   </div>
                                                   <div class="clear"></div>
                                               </div>
                                           </div>
                                       </div>
                                   </div>
                                   
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
         <!-- iraqq  -->
        <div class="section section_four iraq" data-scroll-section>
            <div class="underMainContent">
                <div class="container-fluid">
                    <div class="innerMain">
                        <div class="sectionInner">
                            
                            <div class="section-Text-Overlay" data-scroll data-scroll-speed="3">
                                <h4 class="text-uppercase">زين العراق</h4>
                            </div>
                            <div class="main_content small-width height-for-center">
                                <div class="container_grid">
                                   <div class="row first_row">
                                       <div class="col-sm-6 mx-auto mx-md-0 mx-3" data-scroll data-scroll-speed="4">
                                           <div class="main_card first_card">
                                               <div class="card_custom">
                                                   <div class="cardImage image-reveal">
                                                       <div class="revealer"></div>
                                                       <img src="@/assets/images/custumer/iraq-1.png" alt="" class="img-fluid">
                                                   </div>
                                                   <div class="cardCotent">
                                                       <p>أطلقت شركة زين العراق خدمة الرسائل القصيرة القائمة على المواقع، وهي الخدمة التي تُمكّن الشركات من الترويج لمنتجاتها لدى جمهور ضمن موقع جغرافي معين.
                                                       </p>
                                                       
                                                   </div>
                                               </div>
                                           </div>
                                       </div>
                                       <div class="col-sm-6 mx-auto mx-md-0 mx-3" data-scroll data-scroll-speed="3">
                                           <div class="main_card ">
                                               <div class="card_custom card_two">
                                                   <div class="cardImage image-reveal">
                                                       <div class="revealer"></div>
                                                       <img src="@/assets/images/custumer/iraq-2.png" alt="" class="img-fluid">
                                                   </div>
                                                   <div class="cardCotent">
                                                       <p>هذه الخدمة النصية ذات الاتجاهين التي تقدمها الشركة تُمكّن الشركات من التفاعل بشكل أفضل مع عملائها، وذلك من خلال إقامة تفاعلات هادفة مع جماهيرها.
                                                       </p>
                                                   </div>
                                               </div>
                                           </div>
                                       </div>
                                       <div class="col-sm-6 mx-auto mx-md-0 mx-3" data-scroll data-scroll-speed="1">
                                           <div class="main_card">
                                               <div class="card_custom">
                                                   <div class="cardImage image-reveal">
                                                       <div class="revealer"></div>
                                                       <img src="@/assets/images/custumer/iraq-3.png" alt="" class="img-fluid">
                                                   </div>
                                                   <div class="cardCotent">
                                                       <p>أطلقت شركة زين العراق عرضاً جديداً للنطاق العريض المتنقل يستهدف المؤسسات التجارية والحكومية في العراق.
                                                       </p>
                                                       
                                                   </div>
                                               </div>
                                           </div>
                                       </div>
                                       <div class="col-sm-6 mx-auto mx-md-0 mx-3" data-scroll data-scroll-speed="1">
                                           <div class="main_card ">
                                               <div class="card_custom card_two">
                                                   <div class="cardImage image-reveal">
                                                       <div class="revealer"></div>
                                                       <img src="@/assets/images/custumer/iraq-4.png" alt="" class="img-fluid">
                                                   </div>
                                                   <div class="cardCotent">
                                                       <p>بدأت منصة زين العراق لخدمات B2B في تزويد الشركات الصغيرة والمتوسطة والمشروعات الكبيرة بمنتجات   Microsoft 365  لإدارة أعمالها بفعالية، من خلال شريكتها، شركة ”أول للاتصالات“.
                                                       </p>
                                                   </div>
                                               </div>
                                           </div>
                                       </div>
                                   </div> 
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- dif  -->
        <div class="section section_four" data-scroll-section>
            <div class="underMainContent">
                <div class="container-fluid">
                    <div class="innerMain">
                        <div class="sectionInner">
                            <!-- <div class="section-title">
                                <h5>COMMERCIAL <span>&</span> CUSTOMER EXPERIENCE</h5>
                            </div> -->
                            <div class="section-Text-Overlay right--50" data-scroll data-scroll-speed="-6">
                                <h4 class="text-uppercase small">نمو الإيرادات لـ  ”زين للأعمال“ في 2020</h4>
                            </div>
                            <div class="main_content height-for-center large-width ">
                                <div class="container_grid">
                                   <div class="row first_row">
                                       <div class="col-md-8 mx-md-auto mx-3" data-scroll data-scroll-speed="1">
                                           <div class="desc">
                                               <p>على الرغم من التباطؤ في النشاط الاقتصادي الذي تسببت فيه جائحة كوفيد-19، وسياسات التخفيف الحكومية، حققت ”زين للأعمال“ نمواً قوياً في الإيرادات في العام 2020.</p>
                                                <p>جاء هذا النمو مدفوعاً بتوسيع قاعدة العملاء، بما في ذلك حسابات المكاتب المنزلية، الشركات الصغيرة والمتوسطة، حسابات الشركات الكبيرة، والجهات الحكومية، فضلاً عن زيادة انتشار المنتجات غير المتنقلة، مع التركيز على الخدمات الثابتة.</p>
                                                <p>حقق قطاع ”إنترنت الأشياء“ نموا جيدا خلال هذه الفترة، حيث حصلت زين على مئات الآلاف من عقود العدَّادات الذكية الجديدة في كل من الأردن والعراق والبحرين، وهو الأمر الذي عزز مكانتها الريادية في السوق في قطاع العدَّادات الذكية.</p>
                                                <p>عملت فرق ”زين للأعمال“ على مستوى شركاتها التابعة، جنباً إلى جنب مع سلطات الصحة العامة لتنفيذ حملات التوعية والمعلومات، ونشر التكنولوجيا لتتبع عدوى كوفيد-19 والحجر الصحي، وتوحيد الجهود مع الحكومات للتخفيف من آثار الجائحة.</p>
                                                <p>كان العملاء في صدارة التفكير دائما خلال مبادرات الاستجابة التي قامت بها الشركة مع جائحة كوفيد-19، إذ نفذت شركات زين مبادرات الدعم التالية لمساعدة عملاء الـ B2B في التخفيف من تأثير الجائحة على الأعمال:</p>
                                           </div>
                                       </div>
                                       <div class="col-md-4 mx-md-auto mx-3">
                                            <div>
                                                <div class="img_floting image-reveal">
                                                    <div class="revealer"></div>
                                                    <img src="@/assets/images/custumer/zain-businees.png" alt="" class="img-fluid">
                                                </div>
                                                <div class="text_floting">
                                                    <p>في الكويت، تراوح دور شركة زين بين تزويد العاملين في الخطوط الأمامية ومراكز الحجر الصحي بالاتصالات التي يحتاجون إليها، وابتكار حل كامل لمراقبة الالتزام بتوجيـهـات الحكـومـة الخـاصـة بالعزل الصحي. تم تحقيق هذا الدور الأخير من 
                                                        خلال ابتكار التطبيق المتنقل” شلونك” داخلياً وتزويد المستخدمين بالأساور الذكية، وساعدت هذه الجهود في الحد من انتشار الفيروس.
                                                    </p>
                                                </div>
                                            </div>
                                       </div>
                                   </div>
                                   
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div  class="section section_revenue" data-scroll-section>
            <div class="underMainContent">
                <div class="container-fluid">
                    <div class="innerMain">
                        <div class="sectionInner">
                            
                            <div class="main_content height-for-center">
                                <div class="container_grid">
                                   <div class="row justify-content-center col-gap-10">
                                       <div class="col-md-3 col-sm-6 mx-sm-auto mx-3" >
                                           <div class="revenue-box">
                                               <h5>خدمات توصيل</h5>
                                               <p>توصيل بطاقات SIM والأجهزة إلى عملاء (B2B)، وهو الأمر الذي أسهم في تأمين استمرارية الأعمال على الرغم من حالات حظر التجول والقيود على الحركة.</p>
                                           </div>
                                       </div>
                                       <div class="col-md-3 col-sm-6 mx-sm-auto mx-3" >
                                           <div class="revenue-box">
                                               <h5>رخص استخدام<br>”Microsoft Teams“ مجانية</h5>
                                               <p>عرض حصري يتألف من رخص ”Microsoft Teams“ مجانية (لوقت محدد) تم عرضها لدعم عملائنا من الشركات في إدارة موظفيهم والتواصل معهم.</p>
                                           </div>
                                       </div>
                                       <div class="col-md-3 col-sm-6 mx-sm-auto mx-3" >
                                           <div class="revenue-box">
                                               <h5>Cisco Webex</h5>
                                               <p>عرض لعملاء ”زين للأعمال“ استخدام  Webex لمدة 3 أشهر مجاناً.</p>
                                           </div>
                                       </div>
                                       <div class="col-md-3 col-sm-6 mx-sm-auto mx-3" >
                                           <div class="revenue-box">
                                               <h5>”Microsoft O360“  مجاناً</h5>
                                               <p>عرض حصري يتألف من رخص ”Microsoft O360“ مجانية (لوقت محدد) تم عرضها لدعم عملائنا من الشركات. </p>
                                           </div>
                                       </div>
                                       <div class="col-md-3 col-sm-6 mx-sm-auto mx-3" >
                                           <div class="revenue-box">
                                               <h5>دقائق مجانية</h5>
                                               <p>قدمنا الدعم إلى عملاء الأعمال بدقائق اتصالات صوتية مجانية خلال الجائحة </p>
                                           </div>
                                       </div>
                                       <div class="col-md-3 col-sm-6 mx-sm-auto mx-3">
                                           <div class="revenue-box">
                                               <h5>تسهيل السداد</h5>
                                               <p>تمديد مُهل سداد الفواتير بدون قطع الخطوط لمعظم الحسابات تصميم خطط سداد لدعم العملاء خلال فترات حظر التجول</p>
                                           </div>
                                       </div>
                                       <div class="col-md-3 col-sm-6 mx-sm-auto mx-3" >
                                           <div class="revenue-box">
                                               <h5>باقة بيانات مجانية</h5>
                                               <p>تم توفير باقة بيانات مجانية لعملاء الأعمال خلال الجائحة</p>
                                           </div>
                                       </div>
                                       <div class="col-md-3 col-sm-6 mx-sm-auto mx-3">
                                           <div class="revenue-box">
                                               <h5>حل العمل من المنزل</h5>
                                               <p>وفرنا خدمات النطاق العريض لدعم الموظفين الذين عملوا عن بُعد</p>
                                           </div>
                                       </div>
                                      
                                   </div>
                                   
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="section" data-scroll-section>
            <div class="underMainContent">
                <div class="container-fluid">
                    <div class="innerMain">
                        <div class="sectionInner">
                            <!-- <div class="section-title">
                                <h5>COMMERCIAL <span>&</span> CUSTOMER EXPERIENCE</h5>
                            </div> -->
                            <div class="section-Text-Overlay" data-scroll data-scroll-speed="2">
                                <h4 class="text-uppercase">الرقمنة بشكل أفضل لعملاء B2B </h4>
                            </div>
                            <div class="main_content height-for-center">
                                
                                <p class="mb-40">كانت منظومة ”شركاء زين“، الذين تأثروا مثل معظم الشركات بالإغلاقات الاقتصادية، مدعومة بخطوط سيولة نقدية محددة، مما ساعدهم في الحفاظ على قدرات المبيعات والخدمات، ومستويات التوظيف، ومعايير خدماتية عالية.
                                في إطار السعي إلى الرقمنة الكاملة لعملياتنا التشغيلية، شهد العام 2020 سلسلة من الإنجازات الرئيسية المهمة.</p>
                                <div class="row">
                                    <div class="col-md-5 p-relative left-section">
                                       
                                        <div class="img_floting image-reveal">
                                            <div class="revealer"></div>
                                            <img src="@/assets/images/custumer/digitalized-1.png" alt="" class="img-fluid">
                                        </div>
                                        <div class="text_float">
                                            <p data-aos="fade-left">تطبيق للشركات الصغيرة والمتوسطة في الكويت: كجزء من تركيزها الاستراتيجي على قطاع الشركات الصغيرة والمتوسطة، كانت شركة زين الكويت أول شركة اتصالات في الكويت تقدم منصة رقمية شاملة. هذا التطبيق يتيح للعملاء من الشركات الصغيرة والمتوسطة في الكويت الوصول إلى مجموعة واسعة من الخدمات الرقمية التي تتيحها ”زين للأعمال“، وذلك من خلال نقرة زر واحدة، دون الحاجة إلى الحضور المادي.
                                            </p>
                                            <p>استحوذ هذا الحل المتقدم على قبول واسع النطاق، حيث تم تسجيل أكثر من 1,000 شركة في التطبيق، حيث باتت تستخدمه تلك الشركات بنشاط. </p>
                                        </div>
                                        <div class="clear"></div>
                                    </div>
                                    <div class="col-md-7 right-section">
                                        <div class="innerBox upperBox">
                                            <div class="box_container">
                                                <div class="img_floting image-reveal">
                                                    <div class="revealer"></div>
                                                    <img src="@/assets/images/custumer/digitalized-2.png" alt="" class="img-fluid">
                                                </div>
                                                <div class="text_float">
                                                    <p data-aos="fade-left">توليد المعلومات رقمياً: جميع شركات  زين تُمكّن العملاء المحتملين من طلب عـروض أسعـار الخدمـات، واجتماعـات المبيعـات، ومعلومـات المنتجـات عبـر وسـائـل التـواصـل الاجتمـاعـي. يتـم استهـداف العمـلاء المحتمليـن لكـل خط خدمة من خطوط زين بمعلومات المنتج ذات الصلة بناء على ملفات تعريفهم الشخصية.
                                                    </p>
                                                </div>
                                                <div class="clear"></div>
                                            </div>
                                        </div>
                                        <div class="innerBox bottomBox">
                                            <div class="box_container">
                                                <div class="img_floting image-reveal">
                                                    <div class="revealer"></div>
                                                    <img src="@/assets/images/custumer/digitalized-3.png" alt="" class="img-fluid">
                                                </div>
                                                <div class="text_float">
                                                    <p data-aos="fade-left">العقود الرقمية: أدخلت شركة زين السعودية الرقمنة الكاملة إلى عملية إبرام العقود لديها، وذلك من خلال إزالة الطابع المادي عن العقود مع تأمين المعاملة من بدايتها إلى نهايتها من خلال التكامل مع قاعدة البيانات الحكومية وإجراءات ”كلمة المرور لمرة واحدة“ (OTP) للتصديق على الأطراف الموقّعة.</p>
                                                </div>
                                                <div class="clear"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="section brand" data-scroll-section>
            <div class="underMainContent">
                <div class="container-fluid">
                    <div class="innerMain">
                        <div class="sectionInner">
                            <div class="section-Text-Overlay" data-scroll data-scroll-speed="2">
                                <h4 class="text-uppercase">الترويج للعلامة التجارية ”زين للأعمال“ </h4>
                            </div>
                            <div class="main_content height-for-center">
                                
                                <p class="mb-40">شهد العام 2020 توحيد العلامة التجارية ”زين للأعمال“، التي تعمل كمظلة لجميع محافظ الـ B2B، تشمل: الخدمات المتنقلة والثابتة، إنترنت الأشياء، الخدمات المُدارة المستضافة، خدمات الأمن المُدارة.  <br>
                                تُستخدم هذه العلامة التجارية الآن على نطاق واسع في جميع عمليات زين في مواقع مواد الدعم، الكتيبات، العروض التقديمية للعملاء، العقود، بوابات الرعاية الذاتية، والعديد من الحملات.</p>
                                <div class="row">
                                    <div class="col-sm-6 p-relative left-section">
                                       
                                        <div class="img_floting image-reveal">
                                            <div class="revealer"></div>
                                            <img src="@/assets/images/custumer/zain-brand.png" alt="" class="img-fluid">
                                        </div>
                                        <div class="text_float">
                                            <p data-aos="fade-left">شركة زين الكويت كانت هي الراعي الاستراتيجي لأكبر معرض للتكنولوجيا في الكويت - معرض الكويت للتكنولوجيا 2020: الدعم الاستراتيجي من جانب زين لهذا الحدث يؤكد التزام الشركة بالتواجد في مختلف الأنشطة والبرامج التي تُسهم في رحلة التحول الرقمي في الكويت.  شاركت في المعرض شركات عالمية ومحلية كبيرة من قطاعي التكنولوجيا والاتصالات، بالإضافة إلى العديد من الجهات الحكومية، وحضره أكثر من 25,000 مشارك. 
                                            </p>
                                            <p data-aos="fade-left">من خلال جناحها المتميز المتسم بالحداثة، عرضت زين قدراتها كشريك نشط في تمكين حياة ذكية ومجتمع آمن وقطاع أعمال فعال من خلال تقديم الخدمات والحلول الرقمية الأكثر تقدماً.</p>
                                        </div>
                                        <div class="clear"></div>
                                    </div>
                                    <div class="col-sm-6 right-section">
                                        <div class="innerBox upperBox">
                                            <div class="box_container">
                                                <div class="img_floting image-reveal">
                                                    <div class="revealer"></div>
                                                    <img src="@/assets/images/custumer/zain-brand-2.png" alt="" class="img-fluid">
                                                </div>
                                                <div class="text_float">
                                                    <p data-aos="fade-left">استعرضت شركة زين السعودية خدماتها في قطاع حلول الأعمال في الحدث السعودي لإنترنت الأشياء الذي أقيم في مارس 2020 في العاصمة الرياض.  من خلال ”زين للأعمال“، عرض فريق شركة زين السعودية أحدث التقنيات وإنترنت الأشياء وحلول المدينة الذكية، بالإضافة إلى ذلك، تم عرض باقات اتصال عبر شبكة الجيل الخامس تشمل حِزم ”إنترنت أشياء“، خيارات اتصال، وتطبيقات للتواصل بين الأجهزة (M2M)، وذلك لتمكين إدارة الأعمال ودمجها في قطاعات متنوعة، بما في ذلك: النقل، الخدمات اللوجستية، الرعاية الصحية، الطاقة، إدارة المرافق، الخدمات العامة، التجزئة، وغير ذلك.
                                                    </p>
                                                    <p data-aos="fade-left">علاوة على ذلك، قدمت شركة زين السعودية ”سحابة زين“ لشركات الأعمال والشركات الصغيرة والمتوسطة، إلى جانب تطبيقات الطائرات بدون طيار عبر ”زين درون“، حيث تعتمد خدمات جمع البيانات وتحليلها عبر استخدام تحليلات الذكاء الاصطناعي وتقنيات الشبكات السحابية.
                                                    </p>
                                                </div>
                                                <div class="clear"></div>
                                            </div>
                                        </div>
                                        
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- dif -->

        <!-- new added  -->
        <!-- Muddusar Last Sections -->
        <div class="section last_seven text" data-scroll-section>
            <div class="underMainContent">
                <div class="container-fluid">
                    <div class="innerMain">
                        <div class="sectionInner">
                            
                            <div class="section-Text-Overlay" data-scroll data-scroll-speed="2">
                                <h4 class="text-uppercase small">”زين داتا بارك“ </h4>
                            </div>
                            <div data-scroll data-scroll-speed="2">
                                
                                    <div class="main_content height-for-center">
                                        <div class="row custom_container">
                                            <div class="col-md-12">
                                                <div class="main_content">
                                                    <div class="text_float">
                                                        <p>”زين داتا بارك“ (ZDP) هي شركة جديدة تلعب دوراً حيوياً في رحلة زين لتصبح مزود خدمات رقمية، تم إطلاقها في الكويت والأردن، وهي المسؤولة عن محافظ الخدمات المُدارة والأمنية المستضافة، وهي الخدمات المتاحة لعملاء B2B من خلال شركات زين العاملة.  تقوم فرق المبيعات لدينا - مدعومة بمهندسي الحلول - بتصميم حلول متكاملة مناسبة للاتصالات البيانات LAN/WAN، وأمن وتخزين وتحويل البيانات.
                                                        </p>
                                                        <p>يعتبر مركز ”زين داتا بارك“ عنصراً رئيسياً في استراتيجية زين للأعمال التجارية لتصبح لاعباً متكاملاً في مجال تكنولوجيا المعلومات والاتصالات، وتلبية احتياجات العملاء لنقل البيانات وتحويلها وتخزينها وتأمينها على مستوى كافة أسواقها.</p>
                                                        <p>بفضل الاستفادة من شبكة مراكز البيانات الإقليمية التابعة لمجموعة زين - التي تشمل مركز The Bunker الفريد من نوعه في الشرق الأوسط من حيث التحصين النووي - فإن محفظة الخدمات المدارة الخاصة بمركز ”زين داتا بارك“ تشتمل على مجموعة واسعة من الخدمات السحابية التي تتراوح بين الأجهزة الافتراضية وخدمات مراكز البيانات الخاصة الافتراضية، وهي الخدمات التي يمكن تنفيذها من خلال مجموعة متنوعة من السيناريوهات سواء داخل المقر من مراكز بيانات زين، أو في إعدادات بيئات هجينة.</p>
                                                       <p>بفضل قدرات إدارة البيانات التي يتمتع بها مركز ”زين داتا بارك“، تشمل عروض منتجاتنا خدمات التعافي من الكوارث، حيث يعمل مهندسو الحلول لدينا جنباً إلى جنب مع مدراء التكنولوجيا التنفيذيين ومدراء المعلومات التنفيذيين لتنفيذ استراتيجيات تراعي توفير حلول الإتاحة العالية للبيانات والأنظمة المهمة الخاصة بالشركات.</p>
                                                       <p>يقوم مركز ”زين داتا بارك“ بتوسيع نطاق خدماته من طبقة ”البنية التحتية كخدمة“ (IaaS) إلى طبقة ”البرمجيات كخدمة“ (SaaS)، مع ما يصاحب ذلك من عروض موسعة تشمل بالفعل ”المراقبة بالفيديو“ (VSaaS) و”الخدمات المصرفية“ (BaaS).</p>
                                                        <p>محفظة الأمن، تعتمد على ثلاث ركائز: تقييم المخاطر، ومنع المخاطر، وإدارة المخاطر، ويمكن لمستشاري الأمن لدينا تحديد المخاطر الأمنية ونقاط  الضعف لدى الكيانات الحكومية والشركات من خلال منهجيات التدقيق واختبارات التسلل، ويمكنهم بعد ذلك تخفيف المخاطر من خلال تصميم سياسة أمنية، ونشر التكنولوجيا، وممارسات الإدارة.</p>
                                                        <p>يتولى مركز ”زين داتا بارك“ أيضاً تشغيل ”مركز عمليات أمن زين“، الذي تدير زين من خلاله منصات وسياسات الأمن لجميع شركاتها ولعملائها من الكيانات الحكومية.</p>
                                                        <p>تم دمج الخدمات المُدارة المستضافة وحلول الأمن من ”زين داتا بارك“ مع محفظتيّ الأعمال التجارية (B2B) الخاصتين بشركتي زين الكويت وزين الأردن، ويتم نشر هذه الخدمات حاليا في بعض أكبر المؤسسات في كلتا الدولتين، وفي الوقت الحاضر تملك زين خطط طموحة لتمديد نطاق انتشار ”زين داتا بارك“ وتقديم خدمات جذابة على مستوى المنطقة ككل.</p>
                                                    </div>
                                                    <div class="clear"></div>
                                                </div>
                                            </div>
                                            
                                            
                                        </div>
                                        
                                    </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="section last_seven images-sec" data-scroll-section>
            <div class="underMainContent">
                <div class="container-fluid">
                    <div class="innerMain">
                        <div class="sectionInner">
                            
                            
                            <div>
                                
                                    <div class="main_content height-for-center">
                                        <div class="row custom_container">
                                            
                                            <div class="col-lg-5 col-sm-6">
                                                
                                                    <div class="text_float">
                                                        <div class="headingOne">
                                                            <h4 class="font-weight-bold">مركز بيانات شركة زين الكويت</h4>
                                                            <div class="image-reveal mt-2">
                                                                <div class="revealer"></div>
                                                                <img src="@/assets/images/custumer/dataPark1.png" alt="" class="img-fluid">
                                                            </div>
                                                            <div class="image-reveal mt-2">
                                                                <div class="revealer"></div>
                                                                <img src="@/assets/images/custumer/dataPark2.png" alt="" class="img-fluid">
                                                            </div>
                                                            <div class="image-reveal mt-2">
                                                                <div class="revealer"></div>
                                                                <img src="@/assets/images/custumer/dataPark3.png" alt="" class="img-fluid">
                                                            </div>
                                                        </div>
                                                        
                                                        
                                                    </div>
                                                
                                            </div>
                                            <div class="col-lg-5 col-sm-6">
                                                
                                                    <div class="text_float">
                                                        <div class="headingOne">
                                                            <h4 class="font-weight-bold">مركز بيانات شركة زين الأردن</h4>
                                                            <div class="image-reveal mt-2">
                                                                <div class="revealer"></div>
                                                                <img src="@/assets/images/custumer/dataPark4.png" alt="" class="img-fluid">
                                                            </div>
                                                            <div class="image-reveal mt-2">
                                                                <div class="revealer"></div>
                                                                <img src="@/assets/images/custumer/dataPark5.png" alt="" class="img-fluid">
                                                            </div>
                                                        </div>
                                                    </div>
                                                
                                            </div>
                                            
                                        </div>
                                        
                                    </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="section last_six" data-scroll-section>
            <div class="underMainContent">
                <div class="container-fluid">
                    <div class="innerMain">
                        <div class="sectionInner">
                            <!-- <div class="section-title">
                                <h5>COMMERCIAL <span>&</span> CUSTOMER EXPERIENCE</h5>
                            </div> -->
                            <div class="section-Text-Overlay" data-scroll data-scroll-speed="-3">
                                <h4 class="text-uppercase small">  NXN - تقديم خدمات ذكية ورقمية</h4>
                            </div>
                            <div data-scroll data-scroll-speed="2">
                                <div class="main_content height-for-center">
                                    <div class="container_grid">
                                        <div class="row first_row align-items-center" data-scroll data-scroll-speed="-1">
                                            <div class="col-md-7">
                                                
                                                <div class="img_floting image-reveal">
                                                    <div class="revealer"></div>
                                                    <img src="@/assets/images/custumer/NXN2.png" alt="" class="img-fluid">
                                                </div>
                                                <div class="text_float">
                                                    <p>شركة NXN هي ذراع الخدمات الذكية والرقمية لمجموعة زين، وهي تقود تطوير منتجات زين الرقمية وعروض البيانات الضخمة، وقد منحت NXN الأولوية لتطوير الأمن الذكي، والرعاية الصحية الرقمية، وتتبُّع الأصول، وحلول المدن/الأحياء الذكية. 
                                                    إن خدمة ”الأمن الذكي“ (SECaaS) التي تقدمها شركة NXN  هي خدمة متطورة وشاملة تُمكّن الشركات من حماية أفرادها وأصولها ومرافقها، وفي الوقت ذاته تتميز بإدارة متقدمة لقدرات مراقبة بالفيديو وقدرات تحليلية تلبي احتياجات المراقبة المتطورة. 
                                                    تقدم شركة NXN خدمة أمن رقمي فريدة ومبتكرة وفعالة من حيث التكلفة وتعمل بسلاسة مع أعلى مستوى من التكامل بين إنترنت الأشياء والأتمتة والذكاء والتحكم والبساطة، إذ تجمع في حل واحد بين المراقبة بالفيديو والذكاء الاصطناعي، وتحليلات الفيديو الذكية وإدارة الحوادث، وكل ذلك في نموذج تسعيري على أساس الدفع لكل استخدام.
                                                    </p>
                                                </div>
                                                <div class="clear"></div>
                                                    
                                            </div>
                                            <div class="col-md-5">

                                                <div class="img_floting image-reveal">
                                                    <div class="revealer"></div>
                                                        <img src="@/assets/images/custumer/NXN4.png" alt="" class="img-fluid">
                                                </div>
                                                <div class="text_float">
                                                    <p>شركة NXN هي واحدة من الشركات الرائدة في دورة ”غارتنر هايب سايكل“ لتقنيات وحلول المدن الذكية خلال العام 2020، حيث تم تكريم الشركة بالاعتراف بها كمسوِّق رائد في خمس فئات، وهي: مراكز عمليات المدن؛ ”المدينة الذكية“ (SCaaS)؛ تبادل البيانات؛  منظومة أعمال المدن الذكية الصديقة للبيئة؛ ومنظومة أعمال المدن الذكية، وقد سلط هذا التكريم الضوء على العناصر الرئيسية لعرض القيمة الخاصة بأعمالها.</p>
                                                </div>
                                                <div class="clear"></div>
                                                    
                                            </div>
                                        </div>
                                        <div class="row second_row justify-content-center" data-scroll data-scroll-speed="-1">
                                            <div class="col-md-12">
                                                <div class="main_card card_three">
                                                    <div class="card_custom">
                                                        <div class="cardImage image-reveal">
                                                            <div class="revealer"></div>
                                                           <img src="@/assets/images/custumer/NXN1.png" alt="" class="img-fluid">
                                                        </div>
                                                        <div class="cardCotent">
                                                            <p>حلول الرعاية الصحية الرقمية من NXN عبارة عن منصة خدمات شاملة من أجل سلسلة الرعاية الصحية لإدارة رحلة المريض من البداية إلى النهاية، ابتداءً من المواعيد الطبية ومروراً بالمنصة الرقمية للاستشارات عن بُعد، وانتهاءً بإدارة الوصفات الطبية والسجلات الطبية الإلكترونية.
                                                                حققت شركة NXN حضورا متميزا في فعالية معرض الكويت للتكنولوجيا (Kuwait Tech) في فبراير الماضي، حيث عرضت حلول لمراقبة المرضى عن بُعد، وهي أحد خدمات NXN في قطاع الرعاية الصحية.
                                                                طورت NXN خدمة تحليلات متقدمة فريدة وقوية، التي تساعد العملاء في تصميم وتحويل وتشغيل العمليات الذكية بالاستفادة من الذكاء الاصطناعي والتحليلات المدمجة، يمكن لتحليلات NXN المتقدمة أن تنشر ذكاء الأعمال لدعم أي نوع من العمليات أو الإجراءات أو تفاعلات العملاء فور حدوثها.
                                                                تعمل تحليلات NXN المتقدمة من خلال الدمج بين مصادر البيانات من أنظمة مختلفة بسلاسة، وهو الأمر الذي يسمح بإنشاء رؤى بيانات مدمجة متعمقة مدعومة بالذكاء الاصطناعي ومتعددة الوظائف، بهذا نسهل على عملائنا من الشركات الجمع بين استراتيجية الأعمال والبيانات وعلوم وتكنولوجيا البيانات، وذلك من أجل أن تصبح المؤسسة العميلة أكثر مرونة وكفاءة وربحية. 

                                                                تم تكريم قدرات شركة NXN الرقمية من جانب tahawultech.com ضمن ”جوائز المشاريع المستقبلية 2020“، وذلك باعتبارها الفائزة بجائزة ”أفضل مزود حلول مدن ذكية خلال العام“.
                                                            </p>
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="section last_five" data-scroll-section>
            <div class="underMainContent">
                <div class="container-fluid">
                    <div class="innerMain">
                        <div class="sectionInner">
                            <!-- <div class="section-title">
                                <h5>COMMERCIAL <span>&</span> CUSTOMER EXPERIENCE</h5>
                            </div> -->
                            <div class="section-Text-Overlay" data-scroll data-scroll-speed="2">
                                <h4 class="text-uppercase">العلامة التجارية </h4>
                            </div>
                            <div class="main_content height-for-center">
                                <div class="row custom_container" data-scroll data-scroll-speed="3">
                                    <div class="col-md-12">
                                        <div class="main_content mt-20">
                                            <div class="img_mxWidth img_floting image-reveal">
                                                <div class="reveal"></div>
                                                <img src="@/assets/images/custumer/boardImage.png" alt="" class="img-fluid">
                                            </div>
                                            <div class="text_float">
                                                <div class="text-title">
                                                    <h4 class="text-center font-weight-bold">علامة تجارية تأسر المخيلة</h4>
                                                </div>
                                                <p>
                                                    تركز مجموعة زين على تعزيز مكانة علامتها التجارية كأقوى وأكثر علامة تجارية تأسر مخيلة الجمهور في قطاع الاتصالات، وحيث تعكف على تنفيذ استراتيجية طموحة تنقلها إلى حقبة جديدة في مسيرتها الرائدة، بالتحول إلى مزود اتصالات رقمي، كثفت  المجموعة من حملات وقنوات اتصالها لحث عملائها على مواكبة هذه الحقبة، والتعرف على الإمكانات الهائلة للقدرات الرقمية.
                                                    أسرت زين مخيلة الجمهور خلال هذه الفترة الاستثنائية بفضل ابتكاراتها الرقمية، ومبادراتها المرتبطة بمجالات الاستدامة، وذلك من خلال إطلاق سلسلة من الحملات التسويقية التلفزيونية والرقمية، التي كانت سببا في التقرب من العملاء والجمهور خلال الجائحة. 
                                                    وبفضل هذه المبادرات والحملات النشطة، ارتفع تقييم العلامة التجارية ” زين “ في العام 2020 بنسبة 10% ليصل إلى 2.55 مليار دولار، وذلك وفقا لتقرير “براند فاينانس 2020“ عن العلامات التجارية العالمية، كما حصلت العلامة التجارية على تصنيف ”AA“، يأتي هذا التصنيف بعد 13 عاماً من طرح العلامة التجارية، لذلك يعتبر في حد ذاته شهادة على جدوى الاستثمار الذي قامت به المجموعة خلال هذه الفترة، لكن الأهم من ذلك، أن هذا التصنيف يبرز جودة المنتجات والخدمات التي توفرها محفظة أعمالها.
                                                </p>
                                            </div>
                                            <div class="clear"></div>
                                        </div>
                                    </div>
                                </div>    
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="section last_four" data-scroll-section>
            <div class="underMainContent">
                <div class="container-fluid">
                    <div class="innerMain">
                        <div class="sectionInner">
                            <!-- <div class="section-title">
                                <h5>COMMERCIAL <span>&</span> CUSTOMER EXPERIENCE</h5>
                            </div> -->
                            <div class="section-Text-Overlay" data-scroll data-scroll-speed="2">
                                <h4 class="text-uppercase small">التحوّل الرقمي لتقليل<br>تأثير جائحة كوفيد-19</h4>
                            </div>
                            <div class="main_content height-for-center">
                                <div class="row custom_container" data-scroll data-scroll-speed="3">
                                    <div class="col-md-12">
                                        <div class="main_content ">
                                            <div class="img_floting image-reveal">
                                                <div class="reveal"></div>
                                                <img src="@/assets/images/custumer/digitalTransformation.png" alt="" class="img-fluid">
                                            </div>
                                            <div class="text_float">
                                                <p>دفعت الظروف الصعبة التي تسببت فيها جائحة كوفيد-19إلى تركيز مجموعة زين وشركاتها التابعة على إبقاء العملاء على اتصال دائم (صوت - بيانات) دون انقطاع خلال فترات الإغلاق الكلية والجزئية، للتخفيف من التأثيرات الاجتماعية والاقتصادية، إذ ضاعفت زين من جهودها لتعزيز قدرات وكفاءة الشبكات، وتوفير سلسلة واسعة من الخدمات الرقمية للشركات التجارية والكيانات الحكومية والمجتمعية. تزامن مع هذه الفترة توسع المجموعة في استثماراتها في شبكات الجيل الخامس، وتوفير منتجات وخدمات جذّابة تمتد إلى ما هو أبعد من مجال الاتصالات المتنقلة لتشمل باقة واسعة من الخدمات الرقمية، المحتوى الترفيهي، أتمتة المنازل، الصحة، التكنولوجيا المالية، الطائرات بدون طيار، بالإضافة إلى المدن الذكية.
                                                استثمرت زين ما يقارب الواحد مليار دولار في تحديث شبكات الجيل الرابع على مستوى أسواق عملياتها، كما أطلقت خدمات الجيل الخامس في كل من: الكويت، السعودية، والبحرين، وكان التوسع في شبكة الجيل الخامس في السعودية هو الأكبر في أسواق الشرق الأوسط وشمال أفريقيا، والرابع على المستوى الدولي، وقد ساعد هذا الانتشار المتميز في وضع شركات 
                                                زين في الكويت والسعودية والبحرين على الخريطة  العالمية لشبكات الجيل الخامس.</p>
                                            </div>
                                            <div class="clear"></div>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="section last_three" data-scroll-section>
            <div class="underMainContent">
                <div class="container-fluid">
                    <div class="innerMain">
                        <div class="sectionInner">
                            <!-- <div class="section-title">
                                <h5>COMMERCIAL <span>&</span> CUSTOMER EXPERIENCE</h5>
                            </div> -->
                            <div class="section-Text-Overlay" data-scroll data-scroll-speed="2">
                                <h4 class="text-uppercase small">دعم منظومة بيئة الشركات الناشئة الإقليمية </h4>
                            </div>
                            <div class="main_content height-for-center">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="main_text_wrapper"  data-scroll data-scroll-speed="2">
                                            <p>تدرك زين أن منظومة بيئة ريادة الأعمال تحتاج الآن وأكثر من أي وقت مضى إلى النمو، إذ تحتاج المنطقة إلى التنوع الاقتصادي الذي ينشأ عن مبادرات الابتكار، وعلى هذا الأساس، تركز زين على العديد من مبادرات الابتكار الرقمي ومبادرات دعم الشركات الناشئة.</p>    
                                            <p>إن الشراكة الرقمية القائمة بين زين و”مسابقة منتدى MIT لريادة الأعمال في العالم العربي” تطوَّرت إلى حدث سنوي ينتظره الآلاف من رواد الأعمال العرب الشباب، الذين يرون أنها منصة تتيح لهم عرض أفكارهم الإبداعية والمبتكرة، وتواصل زين دعم هذه المسابقة انطلاقاً من إيمانها الراسخ بأن مبتكري اليوم هم قادة المستقبل، ومن خلال هذه الشراكة، تتطلع إلى تشجيع الفرص التي تعزز من قوة الابتكار، فدعم مثل هذه الفعاليات يتوافق تماماً مع تطلعات زين في أن تصبح مُشغِّل رائد في الابتكارات الرقمية. </p>
                                            <p>على جانب آخر، تشجع منصّة زين للإبداع (ZINC) في كلٍ من الكويت والأردن العقول الشابة على التفكير والتصرف بشكل خلّاق في بيئة عمل مفتوحة وداعمة، فالهدف هو خلق مناخ ملائم لروّاد الأعمال لتوليد أفكار جديدة وتطويرها إلى فرص قابلة للتطبيق.</p>
                                            <p>إلى جانب ذلك، أتمَّت شركة زين الكويت في يناير 2020 نسختها الخامسة من برنامج ”زين فكرة عظيمة“ لتسريع شركات التكنولوجيا الناشئة، إذ قامت الشركة بجمع مبادريها مع عدد من المستثمرين الإقليميين والعالميين، علاوة على ذلك، شهدت مسابقة ”المبادرة“ التي نظمتها شركة زين الأردن فوز 6 شركات ناشئة، لتواصل مسيرة أخرى من التنافس من خلال المشاركة في مسابقة منتدى MIT لريادة الأعمال في العالم العربي، حيث فازت إحدى هذه الشركات الناشئة، وهي شركة ”Draw It“، بالجائزة الأولى في مسار الأفكار الإبداعية، وهي أداة يمكن للمستخدمين من خلالها التعبير عن مشاعرهم من خلال الرسومات الموجهة للجسم البشري. </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="section last_two" data-scroll-section>
            <div class="underMainContent">
                <div class="container-fluid">
                    <div class="innerMain">
                        <div class="sectionInner">
                            <!-- <div class="section-title">
                                <h5>COMMERCIAL <span>&</span> CUSTOMER EXPERIENCE</h5>
                            </div> -->
                            <div class="section-Text-Overlay" data-scroll data-scroll-speed="2">
                                <h4 class="text-uppercase">التكريمات والجوائز</h4>
                            </div>
                            <div class="main_content height-for-center">
                                <div class="row custom_container">
                                    <div class="col-md-12" data-scroll data-scroll-speed="2">
                                        <div class="main_card">
                                            <div class="card_image image-reveal">
                                                <div class="image-reveal"></div>
                                                <img src="@/assets/images/custumer/AWARDS.png" alt="" class="img-fluid">
                                            </div>
                                            <div class="card_text ml-3">
                                                <p>انتقلت علامة زين التجارية إلى آفاق جديدة من النجاح في العام 2020، واستمرت في إرساء قيمها التي تؤمن بها، وحافظت على التزاماتها اتجاه عملائها وأصحاب المصلحة وموظفيها. <br>
                                                وتقديرا لالتزاماتها والوفاء بوعودها، جاءت مجموعة زين في قائمة ”أفضل أرباب عمل في العالم“ الصادرة عن مجلة الأعمال الأميركية فوربس، لتكون شركة الاتصالات الأولى في المنطقة العربية، والشركة الكويتية الوحيدة التي ظهرت في هذه القائمة، كما أنها جاءت وفقاً للتصنيف العالمي من ضمن أفضل أربع شركات في أسواق الشرق الأوسط.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-12 mt-20" data-scroll data-scroll-speed="1">
                                        <p>
                                             فازت زين بجائزة ”أفضل علامة تجارية“ في حفل توزيع جوائز تيليكوم وورلد لعام 2020، مسجلة بذلك رقماً قياسياً بفوزها للعام السابع على التوالي بهذه الجائزة، بعد أن تم اختيارها من قبل العديد من مؤسسات التصنيف أيضاً كـ ”أفضل مُشغِّل اتصالات“ في منطقة الشرق الأوسط وشمال أفريقيا في مناسبات عديدة على مدار السنوات الأخيرة. <br>
                                            أسهمت النجاحات التي حققتها شركة زين السعودية في إطلاق شبكة الجيل الخامس في فوزها بثلاث جوائز تميُّز من جوائز قمة ”تيليكوم ريفيو“ (Telecom Review)، حيث تم تكريم الشركة في ثلاث فئات، هي: ”أفضل بنية تحتية لشبكة الجيل الخامس“، ”أفضل نمو لمستخدمي الجيل الخامس“، و ”أفضل مزود للحوسبة السحابية“. <br>
                                            حصدت ”زين“ست جوائز في مجالات الإبداع ضمن النسخة الثامنة من فعاليات ”جائزة الكويت للإبداع“ - التي تكرم إبداعات المؤسسات الكويتية - في ثلاث فئات، هي: الإعلان التلفزيوني والرقمي، مجالات العلاقات العامة، أفضل تطبيق إلكتروني حكومي ”شلونك“، وجاءت أربع جوائز ضمن فئة الإعلان التلفزيوني والرقمي تكريماً لأبرز إعلانات زين التلفزيونية خلال العام، وهي: إعلان شهر رمضان المُبارك، إعلان عيد الفطر، إعلان الأعياد الوطنية، والإعلان  الخاص بدور الأم خلال جائحة كوفيد-19، كما حصلت زين على جائزة في فئة أفضل تطبيق حكومي عن تطبيق ”شلونك“ الذي طورته الشركة خلال الجائحة بالتعاون مع وزارة الصحة والجهاز المركزي لتكنولوجيا المعلومات، وأخيراً، حصدت شركة زين في الكويت على جائزة الإبداع في العلاقات العامة.
                                        </p>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="section lastSection" data-scroll-section>
            <div class="underMainContent">
                <div class="container-fluid">
                    <div class="innerMain">
                        <div class="sectionInner">
                            <!-- <div class="section-title">
                                <h5>COMMERCIAL <span>&</span> CUSTOMER EXPERIENCE</h5>
                            </div> -->
                            <div class="section-Text-Overlay" data-scroll data-scroll-speed="2">
                                <h4 class="text-uppercase">وسائل التواصل الاجتماعي</h4>
                            </div>
                            <div class="main_content height-for-center large-width">
                                <div class="row" data-scroll data-scroll-speed="2">
                                    <div class="col-md-6">
                                        <p>شهدت استراتيجية زين الخاصة بالترويج لعلامتها التجارية نشاط واسع النطاق على قنواتها الاجتماعية، التي شهدت زيادة مثيرة في عدد المتابعين والمعجبين، ففي كل عام، ينتظر الجمهور في أسواق الشرق الأوسط حملات زين السنوية بلهفة، خصوصا في شهر رمضان المبارك، إذ استقطب إعلان زين التلفزيوني خلال هذا الشهر 10 ملايين مشاهدة على موقع يوتيوب، في حين اجتذب إعلانها التلفزيوني للعيد أكثر من 16 مليون مشاهدة، وقد حظيت هذه الدعايات بآلاف من التعليقات التي حملت معها إشادات إيجابية. <br>
                                            تسعى زين مع حلول شهر رمضان المبارك إلى تقديم رسالة جديدة عبر إعلاناتها التلفزيونية تلامس أهم القضايا في الحياة، فسرعان ما حقق إعلان زين الرمضاني للعام 2020 إقبالاً كبيراً على منصات التواصل الاجتماعي، حيث تجاوز المحتوى الذي تبلغ مدته 2.35 دقيقة 42 مليون مشاهدة عبر اليوتيوب حتى الآن، وحصد إعلان العيد ”افتحوا الأبواب“ على 43 مليون مشاهدة عبر اليوتيوب، وقد تم عرض كلا الإعلانين لملايين المشاهدين على المحطات التلفزيونية الإقليمية والمحلية في منطقة الشرق الأوسط وشمال أفريقيا. 
                                        </p>
                                    </div>
                                    <div class="col-md-6">
                                        <p>تعكس قوة علامة زين التجارية بشكل أكبر النمو الهائل لجمهورها على شبكات التواصل الاجتماعي، حيث يبلغ عدد المتابعين على مواقعها للتواصل الاجتماعي أكثر من 23 مليون متابع، وتبلغ قاعدة متابعي زين على منصة فيس بوك أكثر من 12 مليون متابع، وعلى تويتر 7.2 مليون متابع؛ وعلى إنستغرام 2.2 مليون متابع؛ وعلى لينكيد-إن 600,000 متابع، وتحصد قنوات زين على منصة يوتيوب ما يقرب من 100 مليون مشاهدة سنوياً. <br>
                                            أسهمت مبادرات زين في كافة المجالات المرتبطة بعملائها وجمهورها في تعزيز وعد علامتها التجارية، إذ تطمح المجموعة من خلال التزامها المتجدد إلى فتح المزيد من الآفاق لعملائها، والعمل على ازدهار مجتمعاتها.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Muddusar Last Sections -->
      </section>
  </div>
</template>

<script>
import locomotiveScroll from 'locomotive-scroll';
import "locomotive-scroll/dist/locomotive-scroll.css";
import "@/assets/sccs/commercialcustomer.scss";
export default {
    name:"commercial-customer",
    components:{
        locomotiveScroll
    },
    data(){
        return{
            scrollSettings: {
                maxHeight: 100,
            }
        }
    },
    methods:{
        scroll(){
            let innerWidth = window.innerWidth;
            let allsection = document.querySelectorAll('.section');
            for (let i = 0; i < allsection.length; i++) {
                const element = allsection[i];
                
                element.style.minWidth = `${innerWidth}px`;
                //`${innerWidth}px`;
            }
            
        },
        noOverFlow(){
                document.querySelector('body').classList.add('light-Slide')
                let $window_width = window.innerWidth;
                
                if ($window_width<=991){
                    document.querySelector('body').classList.add('no-overFlow')
                    
                }
                else{
                    document.querySelector('body').classList.remove('no-overFlow')
                }
        }
    },
    mounted(){
       this.scroll()
        this.imageAnimation()
       this.noOverFlow()
       this.lmS = new locomotiveScroll({
            el: document.querySelector('[data-scroll-container]'),
            smooth: true ,
            direction:"horizontal"
        })
        
    }
}
</script>
<style lang="scss">
    [data-page="commercial-customer"]{
        .verticalLabel{
            background: rgb(248, 247, 247);
            // right: 20px;
        }
    }
</style>
